export const PreventNegativeValues = (e: any) => {
  if (e.code === 'Minus') {
    e.preventDefault()
  }
}
